<div class="modal-header" style="border-bottom: 2px solid #00d398; padding: 1rem 1.5rem;">
  <h4 class="modal-title pull-left" style="font-family: 'Rubik', serif; font-weight: 600;">
    Detalles del vuelo
  </h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>

<div class="modal-body" style="padding: 1.5rem; max-height: 70vh; overflow-y: auto;">
  <!-- Resumen del vuelo (cabecera con origen/destino) -->
  <div class="d-flex justify-content-between align-items-center mb-4 p-3" style="background-color: #f8f9fa; border-radius: 8px;">
    <div class="text-center" style="flex: 1;">
      <h3 style="font-size: 24px; font-weight: 700; margin-bottom: 0; color: #333;">
        {{ getFirstSegment()?.departure?.time | slice:0:5 }}
      </h3>
      <p style="margin-bottom: 0; font-size: 14px; color: #666;">
        {{ getFirstSegment()?.departure?.airport }}
      </p>
      <p style="margin-bottom: 0; font-size: 12px; color: #999;">
        {{ getFirstSegment()?.departure?.city || 'Buenos Aires' }}
      </p>
    </div>

    <div class="text-center" style="flex: 0 0 auto; padding: 0 20px;">
      <div class="d-flex align-items-center">
        <div style="width: 80px; height: 2px; background-color: #00d398;"></div>
        <i class="bi bi-airplane-fill" style="color: #00d398; font-size: 20px; margin: 0 5px;"></i>
        <div style="width: 80px; height: 2px; background-color: #00d398;"></div>
      </div>
      <p style="margin-top: 5px; font-size: 12px; color: #666;">
        {{ formatDuration(flightData?.itinerary[0]?.options[0]?.duration) }}
      </p>
    </div>

    <div class="text-center" style="flex: 1;">
      <h3 style="font-size: 24px; font-weight: 700; margin-bottom: 0; color: #333;">
        {{ getLastSegment()?.arrival?.time | slice:0:5 }}
      </h3>
      <p style="margin-bottom: 0; font-size: 14px; color: #666;">
        {{ getLastSegment()?.arrival?.airport }}
      </p>
      <p style="margin-bottom: 0; font-size: 12px; color: #999;">
        {{ getLastSegment()?.arrival?.city || 'Miami' }}
      </p>
    </div>
  </div>

  <!-- Aerolínea principal -->
  <div class="d-flex align-items-center mb-4">
    <div style="width: 50px; height: 50px; background-color: #f0f0f0; border-radius: 8px; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
      <span style="font-weight: 700; color: #333;">{{ flightData?.fare?.validatingCarrier }}</span>
    </div>
    <div>
      <h5 style="font-weight: 600; margin-bottom: 5px;">{{ flightData?.fare?.validatingCarrier }} - {{ flightData?.fare?.brandName || 'Económica' }}</h5>
      <p style="font-size: 13px; color: #666; margin-bottom: 0;">Operado por GOL Linhas Aereas / American Airlines</p>
    </div>
  </div>

  <!-- Lista de segmentos (vuelos) -->
  <div *ngFor="let segment of getAllSegments(); let i = index; let last = last">
    <div class="flight-segment" style="border-left: 3px solid #00d398; padding-left: 20px; margin-bottom: 20px; position: relative;">

      <!-- Cabecera del segmento -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 style="font-weight: 600; color: #333; margin-bottom: 0;">
          Vuelo {{ i + 1 }} - {{ segment.departure?.city || 'Buenos Aires' }} a {{ segment.arrival?.city || 'Sao Paulo' }}
        </h6>
        <span style="font-size: 12px; background-color: #e9ecef; padding: 3px 8px; border-radius: 12px;">
          {{ segment.departure?.date | date:'dd/MM/yyyy' }}
        </span>
      </div>

      <!-- Horarios -->
      <div class="d-flex mb-3">
        <div style="flex: 1;">
          <p style="font-size: 18px; font-weight: 600; margin-bottom: 0;">{{ segment.departure?.time | slice:0:5 }}</p>
          <p style="font-size: 14px; margin-bottom: 0;">{{ segment.departure?.airport }}</p>
          <p style="font-size: 12px; color: #666;">{{ segment.departure?.city || 'Buenos Aires' }}</p>
        </div>
        <div style="flex: 0 0 auto; padding: 0 20px; text-align: center;">
          <i class="bi bi-arrow-right" style="color: #00d398; font-size: 20px;"></i>
          <p style="font-size: 12px; margin-top: 5px; color: #666;">{{ formatDuration(segment.duration) }}</p>
        </div>
        <div style="flex: 1; text-align: right;">
          <p style="font-size: 18px; font-weight: 600; margin-bottom: 0;">{{ segment.arrival?.time | slice:0:5 }}</p>
          <p style="font-size: 14px; margin-bottom: 0;">{{ segment.arrival?.airport }}</p>
          <p style="font-size: 12px; color: #666;">{{ segment.arrival?.city || 'Sao Paulo' }}</p>
        </div>
      </div>

      <!-- Información del vuelo -->
      <div class="d-flex flex-wrap mb-2" style="gap: 15px;">
        <div>
          <span style="font-size: 12px; color: #666;">Vuelo:</span>
          <span style="font-size: 13px; font-weight: 500; margin-left: 5px;">{{ segment.airline?.code }} {{ segment.flight?.number }}</span>
        </div>
        <div>
          <span style="font-size: 12px; color: #666;">Aeronave:</span>
          <span style="font-size: 13px; font-weight: 500; margin-left: 5px;">{{ segment.flight?.equipment }} {{ segment.flight?.equipmentName || 'Boeing 737MAX' }}</span>
        </div>
        <div>
          <span style="font-size: 12px; color: #666;">Clase:</span>
          <span style="font-size: 13px; font-weight: 500; margin-left: 5px;">{{ segment.cabin?.brandName || segment.cabin?.class || 'Economy' }}</span>
        </div>
      </div>

      <!-- Amenidades -->
      <div class="d-flex flex-wrap" style="gap: 10px; margin-top: 10px;">
        <span *ngIf="segment.amenities?.wifi" style="background-color: #e8f5e9; color: #2e7d32; padding: 4px 10px; border-radius: 16px; font-size: 11px;">
          <i class="bi bi-wifi"></i> Wi-Fi
        </span>
        <span *ngIf="segment.amenities?.usb" style="background-color: #e3f2fd; color: #1565c0; padding: 4px 10px; border-radius: 16px; font-size: 11px;">
          <i class="bi bi-usb"></i> Puerto USB
        </span>
        <span *ngIf="segment.amenities?.outlet" style="background-color: #fff3e0; color: #ef6c00; padding: 4px 10px; border-radius: 16px; font-size: 11px;">
          <i class="bi bi-plug"></i> Tomacorrientes
        </span>
        <span *ngIf="segment.amenities?.entertainment" style="background-color: #f3e5f5; color: #6a1b9a; padding: 4px 10px; border-radius: 16px; font-size: 11px;">
          <i class="bi bi-tv"></i> Entretenimiento
        </span>
        <span *ngIf="segment.amenities?.liveTv" style="background-color: #e1f5fe; color: #0277bd; padding: 4px 10px; border-radius: 16px; font-size: 11px;">
          <i class="bi bi-tv"></i> TV en vivo
        </span>
      </div>

      <!-- Tiempo de conexión (si no es el último segmento) -->
      <div *ngIf="!last && getAllSegments().length > 1" style="margin-top: 15px; padding: 10px; background-color: #fff3e0; border-radius: 8px;">
        <p style="margin-bottom: 0; font-size: 13px;">
          <i class="bi bi-clock-history" style="color: #ef6c00; margin-right: 5px;"></i>
          Tiempo de conexión: <strong>{{ formatDuration(calculateLayover(i)) }}</strong>
          <span style="color: #666; margin-left: 10px; font-size: 12px;">
            ({{ segment.arrival?.time | slice:0:5 }} / {{ getAllSegments()[i+1]?.departure?.time | slice:0:5 }})
          </span>
        </p>
      </div>
    </div>
  </div>

  <!-- Resumen final -->
  <div class="mt-4 p-3" style="background-color: #f8f9fa; border-radius: 8px;">
    <div class="d-flex justify-content-between">
      <div>
        <p style="margin-bottom: 5px; font-size: 14px; color: #666;">Tiempo total de viaje:</p>
        <p style="font-size: 18px; font-weight: 600; color: #333;">{{ formatDuration(flightData?.itinerary[0]?.options[0]?.duration) }}</p>
      </div>
      <div>
        <p style="margin-bottom: 5px; font-size: 14px; color: #666;">Total de escalas:</p>
        <p style="font-size: 18px; font-weight: 600; color: #333;">
          {{ getAllSegments().length - 1 }} {{ (getAllSegments().length - 1) === 1 ? 'escala' : 'escalas' }}
        </p>
      </div>
      <div>
        <p style="margin-bottom: 5px; font-size: 14px; color: #666;">Política de cancelación:</p>
        <p style="font-size: 14px; font-weight: 600; color: #333;">
          {{ flightData?.fare?.cancelPolicy === 'MDNT' ? 'No reembolsable' : 'Reembolsable' }}
        </p>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer" style="border-top: 1px solid #dee2e6; padding: 1rem 1.5rem;">
  <button type="button" class="btn btn-secondary" (click)="closeModal()" style="border-radius: 50rem; padding: 0.5rem 1.5rem;">
    Cerrar
  </button>
  <button type="button" class="btn"
          style="background-color: #00d398; color: white; border-radius: 50rem; padding: 0.5rem 1.5rem;"
          (click)="closeModal()">
    Seleccionar vuelo
  </button>
</div>
